export default __webpack_public_path__ + "static/media/Admlocales.1cce1778.png";